import api from '../request/request'

const productDetailForVariousPlatforms = ({productId, shopId, platform}) => {
    return api.getPromise('product/productDetailForVariousPlatforms', {
        productId, shopId, platform
    })
}

export default {
    productDetailForVariousPlatforms
}




// WEBPACK FOOTER //
// ./src/request/productApi.js